import { countryCodeJson } from "../core/json/CountryCodeJson";

const isEmailValid = () => {
  const regX = new RegExp(
    /^[a-zA-Z0-9_]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/
  );
  return regX;
};

const isPhoneNumberValid = (countryCode: any, phoneNumber: any) => {
  let isPhoneNumberValid = false;
  let phoneNumberLength;
  const selectedCountryCodeData = countryCodeJson.find(
    (item) => item.dial_code === countryCode
  );
  const regx = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  phoneNumberLength = selectedCountryCodeData?.pLength;
  if (regx.test(phoneNumber) && phoneNumber.length === phoneNumberLength) {
    isPhoneNumberValid = true;
  } else {
    isPhoneNumberValid = false;
  }
  return isPhoneNumberValid;
};

const isUserNameAvailable = (userName: any) => {
  const listOfUserNames = [
    {
      name: "punya",
    },
    {
      name: "sheetal",
    },
    {
      name: "michael",
    },
    {
      name: "vikas",
    },
  ];
  let isUserNameAvailable = true;
  listOfUserNames.every((item: any) => {
    if (userName === item.name) {
      isUserNameAvailable = false;
      return false;
    }
    return true;
  });
  return isUserNameAvailable;
};

const isFullNameValid = () => {
  const regX = new RegExp(/^[a-zA-Z ]*$/);
  return regX;
};

const isPasswordValid = () => {
  const regx = /^[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return regx;
};

const isValidPhoneNumber = () => {
  const regx = /^[0-9]{10}$/;
  return regx;
};
const isValidEmail = (email: string) => {
  const regX = new RegExp(
    /^[a-zA-Z0-9_]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/
  );
  return regX.test(email);
};

const isMobileNumberValid = (ph: string) => {
  const regX = new RegExp(/^((?!(0))[0-9]{10})$/);
  return regX.test(ph);
};

const isNameValid = (name: any) => {
  const regX = new RegExp(/^[a-zA-Z ]*$/);
  return regX.test(name);
};
const isEmpty = (str: string) => {
  return str.length === 0 ? true : false;
};
const isOtpValid = (otp: any) => {
  const regX = new RegExp(/^\d*[]?\d*$/);
  return regX.test(otp);
};

const validateUsername = (value: any) => {
  // Rule 1: Max length 30
  if (value.length > 30) {
    return false;
  }

  // Rule 2: Cannot contain the word 'name' (case-insensitive)
  if (/name/i.test(value)) {
    return false;
  }

  // Rule 3: Cannot be only numbers
  if (/^[0-9]+$/.test(value)) {
    return false;
  }

  // Rule 4: Base format (alphanumeric + . or _), no .. or __, and not starting/ending with . or _
  const usernameRegex = /^(?!.*[._]{2})[a-zA-Z0-9._]{1,30}$/;
  if (!usernameRegex.test(value) || value.startsWith('.') || value.endsWith('.')) {
    return false;
  }

  // ✅ All rules passed
  return true;
};


// const validateUsername = (value: any) => {
//   // Regular expression to check the username against the criteria
//   const usernameRegex = /^(?!.*[._]{2})[a-zA-Z0-9._]{1,32}$/;

//   // Check if the username matches the pattern and doesn't start or end with a dot or underscore
//   if (
//     usernameRegex.test(value) &&
//     !value.startsWith(".") &&
//     !value.endsWith(".")
//   ) {
//     return true; // Username is valid
//   } else {
//     return false;
//   }
// }

const ValidationUtils = {
  isEmailValid,
  isPasswordValid,
  isPhoneNumberValid,
  isFullNameValid,
  isUserNameAvailable,
  isValidPhoneNumber,
  isValidEmail,
  isMobileNumberValid,
  isNameValid,
  isEmpty,
  isOtpValid,
  validateUsername
};

export default ValidationUtils;
